import { retirementAllowanceFromApi } from './retirementAllowance/retirementAllowanceMapper';
import { isRetirementAllowanceComplete, isRetirementAllowanceCursor } from './retirementAllowance/retirementAllowanceSteps';
import type { TaxDeclarationProgressPayload } from './taxDeclarationApi';

/** Other-income block finished (gate answered or already handed off to retirement). */
export function isOtherIncomeBlockCompleteFromProgress(data: TaxDeclarationProgressPayload): boolean {
  const gate = data.otherIncomeEarner?.anyClaimedByOther;
  if (gate === true || gate === false) return true;
  return isRetirementAllowanceCursor(data.currentStepId);
}

/** Section 5 complete when both other-income and retirement allowance flows are done. */
export function shouldOtherClaimsSectionBeDone(data: TaxDeclarationProgressPayload): boolean {
  if (data.sectionOtherIncomeDone) return true;
  if (!isOtherIncomeBlockCompleteFromProgress(data)) return false;
  const retirement = retirementAllowanceFromApi(data.retirementAllowance);
  return isRetirementAllowanceComplete(retirement);
}

export function otherClaimsSectionFlagsFromProgress(
  data: TaxDeclarationProgressPayload
): {
  sectionEmployeeDone?: boolean;
  sectionSpouseDone?: boolean;
  sectionDependentsDone?: boolean;
  sectionSpecialDone?: boolean;
  sectionOtherIncomeDone?: boolean;
} {
  return {
    sectionEmployeeDone: data.sectionEmployeeDone,
    sectionSpouseDone: data.sectionSpouseDone,
    sectionDependentsDone: data.sectionDependentsDone,
    sectionSpecialDone: data.sectionSpecialDone,
    sectionOtherIncomeDone: shouldOtherClaimsSectionBeDone(data),
  };
}
